import "babel-polyfill";
import "normalize.css";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import SiteConfig from "./siteConfig";
//import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById("root"));
//registerServiceWorker();

if (
    SiteConfig.hasOwnProperty("zendesk-id") &&
    SiteConfig["zendesk-id"].length > 0
) {
    window.zE ||
        (function(e, t, s) {
            var n = (window.zE = window.zEmbed = function() {
                    n._.push(arguments);
                }),
                a = (n.s = e.createElement(t)),
                r = e.getElementsByTagName(t)[0];
            (n.set = function(e) {
                n.set._.push(e);
            }),
                (n._ = []),
                (n.set._ = []),
                (a.async = true),
                a.setAttribute("charset", "utf-8"),
                (a.src =
                    "https://static.zdassets.com/ekr/asset_composer.js?key=" +
                    s),
                (n.t = +new Date()),
                (a.type = "text/javascript"),
                r.parentNode.insertBefore(a, r);
        })(document, "script", SiteConfig["zendesk-id"]);
}



// WEBPACK FOOTER //
// ./src/index.js